<div [ngClass]="rowClass" *ngIf="!forDownload">
	<label [for]="formElement.name" [ngClass]="labelClass">
		{{formElement.label}}
		<span class="mandatoryColor"
			*ngIf="(label || formElement.label) && (required || formElement.required || formElement.fakeRequired || formElement.showAstrisk)">*</span>
	</label>
	<div [ngClass]="inputClass">
		<div class="row">
			<div [class]="dropdownClass">
			</div>
			<div [class]="uploadInputClass">
				<app-upload-file [api]="formElement.api" [uploadType]="formElement.uploadType"
					[categories]="formElement.categories" [disabled]="disAllow" *ngIf="visible"
					[isPublicTemplateUrl]="formElement.isPublicUrl"
					[documentTemplateUrl]="formElement.documentTemplateUrl" [withoutButton]="uploadOnSelect"
					[allowedFormats]="allowedFormats" [formValue]="formValue" (blur)="onBlur()"
					[isMultiSelect]="isMultiSelect" [fileSizeRestrict]="formElement.maxSize"
					[localFileValue]="localFileValue" [isReviewRequiredSelect]="isReviewRequiredSelect"
					[(localFile)]="localFile" (localFileChange)="onLocalFileChange()" [(value)]="value"
					(valueChange)="onChange()" [info]="formElement.info" [placeholder]="formElement.placeholder"></app-upload-file>
			</div>
		</div>
		<ng-content></ng-content>
	</div>
</div>
<div [ngClass]="rowClass" *ngIf="forDownload">
	<label [ngClass]="labelClass">
		{{formElement.label}}
		<span class="mandatoryColor"
			*ngIf="(label || formElement.label) && (required ||formElement.required || formElement.fakeRequired || formElement.showAstrisk)">*</span>
	</label>
	<div [ngClass]="inputClass">
		<ng-container *ngIf="formElement.uploadType != UPLOAD_TYPE.CATEGORISED">
			<app-file-download [publicUrl]="formElement.isPublicUrl" [fileURL]="value" [buttonText]="downloadText">
			</app-file-download>
		</ng-container>
		<ng-container *ngIf="formElement.uploadType === UPLOAD_TYPE.CATEGORISED">
			<table class="table table-striped">
				<tr>
					<th>{{tableLabel.categoryName}}</th>
					<th>{{tableLabel.file}}</th>
					<th>Download Image</th>
				</tr>
				<tr *ngFor="let category of categorisedFileDetails;let i = index">
					<td>{{category.name}}</td>
					<td>
						<ul>
							<li class="link-text" *ngFor="let fileName of category.fileNames; let i=index;"
								(click)="download(category.downloadUrls[i])">{{fileName}}</li>
						</ul>
					</td>
					<td>
						<p class="link-text1" (click)="previewImages(category)"> Preview
						</p>
					</td>
				</tr>
			</table>
		</ng-container>
	</div>
</div>
<div [ngClass]="rowClass" *ngIf="imageView">
	<div [ngClass]="inputClass">
		<div class="container" style="text-align: center">
			<img #thumbnailLogoChild class="img-responsive-uploaded" [src]="uploadedImageURL || formElement.isPublicUrl">
		</div>
	</div>
</div>
<br>
<app-image-slider *ngIf="showSlider" [(showSlider)]="showSlider" [imageUrls]="sliderImageUrls"></app-image-slider>
<!-- <app-image -->
<!-- <slideshow *ngIf="showSlider" [imageUrls]="sliderImageUrls"></slideshow> -->